export default [
    {
        path: 'agendamento-exame',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-agendamento-exame' */
            '@/views/exame-laboratorial/agendamento-exame/Index'
        ),
        redirect: 'agendamento-exame/index',
        children: [
            {
                name: 'exame-laboratorial-agendamento-exame-index',
                path: 'index',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-agendamento-exame' */
                    '@/views/exame-laboratorial/agendamento-exame/List.vue'
                ),
            },
            {
                name: 'exame-laboratorial-agendamento-exame-create',
                path: 'create/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-agendamento-exame' */
                    '@/views/exame-laboratorial/agendamento-exame/Form.vue'
                ),
            },
        ],
    },
]